define('viewmodels/tournaments/TournamentDetailsDialog',[
    'knockout',
    'underscore'
], function (ko, _) {

    function TournamentDetailsDialog (
        dialog,
        subscribeToLeaderboardUpdates,
        campaignViewModel,
        tournamentViewModel
    ) {

        var self = this,
            disposeExistingLeaderboardSubscriptions,
            SHOW_GAME_NAME_RESET_TIMEOUT = 5000;

        self.campaign = campaignViewModel;
        self.tournament = tournamentViewModel;

        self.showGameNameFor = _.memoize(function () {
            return ko.observable(false).resetAfter(SHOW_GAME_NAME_RESET_TIMEOUT);
        })

        self.show = function () {
            disposeExistingLeaderboardSubscriptions = subscribeToLeaderboardUpdates(self.tournament.playerLeaderboard);
            dialog.showDialog(this);
        };

        self.close = function () {
            disposeExistingLeaderboardSubscriptions();
            dialog.close(this);
        };

    }

    return TournamentDetailsDialog;
});

